import defaultAxios, { AxiosError } from "axios";
import React, { useCallback, useState } from "react";
import Swal from "sweetalert2";
import { useHapusKategoriModal } from "../../context/hapusKategoriModalContext";
import { useKategoriModal } from "../../context/kategoriModalContext";
import axios from "../../services/axios";
import { LoadingButton } from "@mui/lab";
import {
    Dialog,
    DialogTitle,
    Stack,
    IconButton,
    Typography,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTransaksi } from "../../context/transaksiContext";

interface IModalDeleteSubKategoriProps {
    refetch: () => void;
}

const ModalDeleteSubKategori = ({ refetch }: IModalDeleteSubKategoriProps) => {
    const { openModalSubKategori } = useKategoriModal();
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const {
        isOpenModalHapusSubKategori,
        closeModalHapusSubKategori,
        namaSubKategori,
        idSubKategori,
    } = useHapusKategoriModal();
    const { setFetchingItems } = useTransaksi();

    const handleDelete = async (id: string | number | undefined) => {
        setIsButtonLoading(true);
        try {
            const { data } = await axios.delete(
                `/api/subkategori-delete/${id}`,
            );
            if (data.code === 200) {
                // assignWords("Kategori " + namaKategori + " berhasil dihapus!");
                // openAlert();
                Swal.fire({
                    title: namaSubKategori + " berhasil dihapus!",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "success",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
                refetch();
                openModalSubKategori();
                setFetchingItems();
                closeModalHapusSubKategori();
            } else {
                Swal.fire({
                    title: data.message,
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "error",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
            }
            setIsButtonLoading(false);
        } catch (error) {
            // console.error(error);
            setIsButtonLoading(false);
            handleErrorResponse(error);
        }
    };

    const handleErrorResponse = useCallback(
        (error) => {
            if (defaultAxios.isAxiosError(error)) {
                const serverError = error as AxiosError<any>;
                if (serverError && serverError.response) {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `${serverError.response.data.message}`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalHapusSubKategori();
                } else {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `Telah Terjadi Kesalahan`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalHapusSubKategori();
                }
            }
        },
        [closeModalHapusSubKategori],
    );
    return (
        <Dialog
            maxWidth="xs"
            fullWidth={true}
            open={isOpenModalHapusSubKategori}
            onClose={closeModalHapusSubKategori}
            PaperProps={{
                sx: { borderRadius: 1 },
            }}
        >
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton
                        onClick={() => {
                            closeModalHapusSubKategori();
                            openModalSubKategori();
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" fontWeight="bold">
                        Hapus SubKategori
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {namaSubKategori} akan dihapus secara permanen. Yakin ingin
                    menghapus?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                <LoadingButton
                    loading={isButtonLoading}
                    loadingPosition="center"
                    variant="outlined"
                    onClick={() => handleDelete(idSubKategori)}
                    color="error"
                >
                    Hapus
                </LoadingButton>
                <Button
                    variant="contained"
                    onClick={() => {
                        closeModalHapusSubKategori();
                        openModalSubKategori();
                    }}
                    color="error"
                >
                    Tidak
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDeleteSubKategori;
